module.exports = __webpack_public_path__ + "static/media/599.7554 (4).08887c4f.pdf";